module.exports = __webpack_public_path__ + "assets/img/6-1.002f5c9e.png";